import * as Immutable from "immutable";
import { BaseEntity } from "../../baseEntity";
import { GraphicsPanel } from "./graphicsPanel";

export class ConfGraphicsValue extends BaseEntity {

  protected readonly SVG = "svg";
  protected readonly GRAPHICS_PANEL = "graphicsPanel";

  get svg(): string { return this.getInternalValue<string>(this.SVG); }
  setSvg(svg: string): this { return this.setInternalValue(this.SVG, svg); }

  get graphicsPanel(): GraphicsPanel { return this.getInternalValue<GraphicsPanel>(this.GRAPHICS_PANEL); }
  setGraphicsPanel(graphicsPanel: GraphicsPanel): this { return this.setInternalValue(this.GRAPHICS_PANEL, graphicsPanel); }
}